import React, { ChangeEventHandler, useCallback } from 'react';
import IconLink from '../Icon/IconLink';
import { logout } from '../../services/auth';
import { Select } from '../Form';
import useSessionInfo from '../../hooks/useSessionInfo';
import useMode from '../../hooks/useMode';
import { UserMode } from '../../hooks/useApolloClient';
import { navigationLinks } from './Header';
import { useHistory } from 'react-router-dom';
import { IconType } from '../Icon/Icon';

type UserMenuItem = {
  icon: IconType;
  text: string;
  href: string;
};

export const userMenuLinks: Record<UserMode, UserMenuItem[]> = {
  'water-supplier': [
    {
      icon: 'settings',
      text: 'Manage Account',
      href: '/water-supplier/profile',
    },
    { icon: 'people', text: 'Users', href: '/water-supplier/users' },
  ],
  company: [
    { icon: 'settings', text: 'Manage Account', href: '/company/profile' },
    { icon: 'people', text: 'Users', href: '/company/users' },
  ],
  admin: [],
  individual: [],
};

const UserMenu = (): JSX.Element => {
  const { isCompany, isBackflowTester, isWaterSupplier, isAdmin, modes } =
    useSessionInfo();
  const mode = useMode();
  const history = useHistory();
  const setMode = useCallback<ChangeEventHandler<any>>(
    (e) => {
      const newMode: UserMode = e.target.value;
      const links = navigationLinks(newMode);
      if (!links) {
        return;
      }
      let targetLink = links.find((value) =>
        window.location.href.includes(value.href)
      );
      if (!targetLink) {
        targetLink = links[0];
      }
      history.push(`/${newMode}${targetLink.href}`);
    },
    [mode]
  );

  return (
    <>
      {modes && modes.length > 1 && (
        <Select id="mode" name="mode" value={mode} ml={3} onChange={setMode}>
          {isCompany && isBackflowTester && (
            <option value="company">Testing Company</option>
          )}
          {isWaterSupplier && (
            <option value="water-supplier">Water Supplier</option>
          )}
          {isAdmin && <option value="admin">Admin</option>}
        </Select>
      )}
      {userMenuLinks[mode].map((link, index) => (
        <IconLink key={index} pr={8} icon={link.icon} isDark href={link.href}>
          {link.text}
        </IconLink>
      ))}
      <IconLink pr={8} icon="logout" isDark onClick={logout}>
        Log Out
      </IconLink>
    </>
  );
};

export default UserMenu;
